import * as React from "react";
import { SVGProps } from "react";

const BitcoinDiamond = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 55" {...props}>
    <path d="M54.7 5.3 44.6 0H19.7l-9.6 5.4L0 18.7l32.3 36.7 32.3-36.7zm6.6 12.8-12.6 6.4L44.6 12l9.3-4.5zM20.5 2h23.3l7.9 4.1-8 3.8H20.4l-7-3.7zm-9.7 5.5L19 12l-2.9 12.5-13.3-6.7zM5.4 21.6l10.3 5.3 12.6 21.7zm26.8 29.7L17.9 26.5 21.4 12h21.3l3.8 14.1zm3.6-2.8L48.6 27l10.7-5.4z" />
    <path
      fill="#fcc339"
      d="M41.4 28.8a6.1 6.1 0 0 0-2.9-3.2 3 3 0 0 0 1.8-1.7c.2-.6.2-1.1.1-1.7 0 0-.1-.9-.4-1.7-.6-1.3-2.6-2.5-5.4-2.8v-3.2h-2.5v3.2h-1.9v-3.2h-2.6v3.2h-4.1v2.1a3 3 0 0 1 2.2 1.4c.4.6.4 1.1.5 1.4l.2 8c0 1-.4 1.9-1.2 2.4-1 .6-2 .3-2.2.3v2.3h4.5V39h2.7v-3h1.9l.1 3h2.5v-3.3h2.4a5 5 0 0 0 2.6-.7c1.9-1.3 2.5-4.1 1.7-6.2zm-11-7.9h3.2c1.2 0 2.2.9 2.2 2.1s-.9 2.2-2.1 2.2h-3.3zm4 11.8h-3.8V28h3.8c1.2.1 2.2 1.1 2.3 2.2.1 1.3-.9 2.4-2.3 2.5z"
    />
  </svg>
);

export default BitcoinDiamond;
